import { Layout, ActionLogSystem } from "components"
export const ActionLog = () => {
 return (
  <Layout>
   <ActionLogSystem />
  </Layout>
 )
}
